interface ToggleSwitchProps {
    checked: boolean
    onChange: (checked: boolean) => void
    label?: string
}

function ToggleSwitch2({
    checked,
    onChange,
    label,
}: ToggleSwitchProps): React.JSX.Element {
    const handleToggle = () => {
        onChange(!checked)
    }

    return (
        <div className="flex items-center gap-2.5">
            {label && <span className="text-sm">{label}</span>}
            <div
                className={`w-[50px] h-[25px] rounded-full relative cursor-pointer transition-colors duration-300 ${
                    checked ? 'bg-[#4caf50]' : 'bg-[#ccc]'
                }`}
                onClick={handleToggle}
                role="button"
                tabIndex={0}
                aria-pressed={checked}
            >
                <div
                    className={`w-[21px] h-[21px] bg-white rounded-full absolute top-[2px] left-[2px] transition-transform duration-300 transform ${
                        checked ? 'translate-x-[25px]' : 'translate-x-0'
                    }`}
                />
            </div>
        </div>
    )
}

export default ToggleSwitch2
